import { AdminScreen } from '@/features/admin/AdminScreen';

/**
 * Админка.
 *
 * Маршрут открыт всем — закрыт сервер: каждая операция проходит через
 * Edge Function `admin`, которая проверяет роль. Прятать адрес не имеет
 * смысла, а вот прятать пункт меню от обычного пользователя — имеет:
 * ссылка, ведущая к отказу, только сбивает с толку.
 */
export function AdminPage() {
  return (
    <main className="flex flex-col">
      <h1 className="px-6 pt-8 font-display text-h1 text-text">Админка</h1>
      <AdminScreen />
    </main>
  );
}
